'use client'

import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import CustomPopoverOptions from '../customPopoverOptions/page';
import formatMsg from '../../util/formatMsg';
import { accountPackageActions, Helper, NewBookingStatuses, notification, packageActions, permissions, timeutil } from '../..';
import { bookingDetailPdf } from '../../redux/accountPackage/reducer';


const { changeBookingStatus } = packageActions;
const { resetOperations } = accountPackageActions;

function page(props) {
    const { firebase, record, setOpenRescheduleModal, payload, setBeforeCancel, membershipCheck, setSelectedBooking } = props
    const dispatch = useDispatch();
    const [isPopupOpen, setIsPopupOpen] = useState(null);
    const isAccount = Helper.isAccount(firebase);


    const getApproveRejectOptions = () => {
        let options: any = [];

        if (permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.BOOKING_CONFIRM, record?.centerId ? [record.centerId] : []) && record?.status && (record.status === "WAITLISTED" || record.status === "CONFIRMATION_PENDING" || record.status === "ENROLLMENT_PENDING")) {
            options.push({
                image: "/images/Approve.png",
                title: formatMsg("approve"),
                action: () => {
                    setIsPopupOpen(undefined);
                    dispatch(changeBookingStatus({ firebase, record: record?.bookingBasicDetails ? record?.bookingBasicDetails : record, confirmOrNot: true }));
                }
            });
        }

        if (record?.status && record.status !== NewBookingStatuses.CANCELLED) {
            if (permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.BOOKING_RESCHEDULE, record?.centerId ? [record.centerId] : []) && record.status !== NewBookingStatuses.CONFIRMATION_PENDING && record.status !== NewBookingStatuses.WAITLISTED) {
                options.push({
                    image: "/images/RescheduleIcon.png",
                    title: formatMsg("reschedule"),
                    action: () => {
                        setIsPopupOpen(undefined);
                        setOpenRescheduleModal(record.id);
                        setSelectedBooking && setSelectedBooking(record);
                    }
                });
            }

            if (permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.BOOKING_CANCEL, record?.centerId ? [record.centerId] : [])) {
                options.push({
                    image: "/images/Reject.png",
                    title: formatMsg("cancel"),
                    action: () => {
                        setIsPopupOpen(undefined);
                        dispatch(changeBookingStatus({ firebase, record, confirmOrNot: false }));
                        setSelectedBooking(record);
                    }
                });
            }

        }
        if (permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.BOOKING_DOWNLOAD_PDF, record?.centerId ? [record.centerId] : [])) {
            options.push({
                image: "/images/downloadPdf.png",
                title: formatMsg("downloadPdf"),
                action: () => {
                    setIsPopupOpen(undefined);
                    dispatch(bookingDetailPdf({
                        firebase,
                        bookingId: record.id,
                        key: Helper.isAccount(firebase) ? "parentPdfUrl" : "adminPdfUrl"
                    }))
                    setSelectedBooking && setSelectedBooking(record);
                }
            })
        }
        return options;
    };

    const getOptions = () => {
        let options: any = [];
        options.push({
            image: "/images/downloadPdf.png",
            title: formatMsg("downloadPdf"),
            action: () => {
                setIsPopupOpen(undefined);
                dispatch(bookingDetailPdf({
                    firebase,
                    bookingId: record.id,
                    key: Helper.isAccount(firebase) ? "parentPdfUrl" : "adminPdfUrl"
                }))
            }
        })
        if (record?.status && (record.status !== "CANCELLED")) {
            const currentTime = timeutil.getInstance();
            const { startDate } = record;

            const getDeadlineTime = (startDate, duration, durationType) => {
                let deadline = timeutil.getInstance(startDate);

                if (durationType === "hours") {
                    deadline = deadline.subtract(duration, "hour");
                } else if (durationType === "days") {
                    deadline = deadline.subtract(duration, "day");
                }

                return deadline;
            };


            if (membershipCheck && payload.reschedulingRules.allow) {
                const rescheduleDeadline = getDeadlineTime(startDate, payload.reschedulingRules.duration, payload.reschedulingRules.durationType);
                if (currentTime.isBefore(rescheduleDeadline)) {
                    if (record.status != NewBookingStatuses.CONFIRMATION_PENDING && record.status != NewBookingStatuses.WAITLISTED) options.push({
                        image: "/images/RescheduleIcon.png",
                        title: formatMsg("reschedule"),
                        action: () => {
                            setIsPopupOpen(undefined);
                            setOpenRescheduleModal(record.id);
                            setSelectedBooking && setSelectedBooking(record);
                        }
                    });
                }
            }

            if (payload.cancellationRules.allow) {
                const cancelDeadline = getDeadlineTime(startDate, payload.cancellationRules.duration, payload.cancellationRules.durationType);
                if (currentTime.isBefore(cancelDeadline)) {
                    options.push({
                        image: "/images/Reject.png",
                        title: formatMsg("cancel"),
                        action: () => {
                            setIsPopupOpen(undefined);
                            setBeforeCancel(true);
                            setSelectedBooking && setSelectedBooking(record);
                        }
                    });
                }
            }
        }

        return options;
    };

    const options = isAccount ? getOptions() : getApproveRejectOptions();

    return (
        <>
            {
                options?.length > 0 &&
                <CustomPopoverOptions
                    open={isPopupOpen === (record?.id || record?.bookingBasicDetails?.id)}
                    setOpen={setIsPopupOpen}
                    recordId={record?.id || record?.bookingBasicDetails?.id}
                    options={options}
                />
            }
        </>
    )
}

export default page
